export const getIssueTitlePreview = ({ category, sub_category, custom_title }) => {
  if (category === 'Other') {
    return (custom_title || '').trim() || 'Custom issue';
  }

  if (sub_category) {
    return `${category} - ${sub_category}`;
  }

  return category || 'Issue';
};

export const getIssueDescriptionTemplate = (issueDetails) => {
  const issueTitle = getIssueTitlePreview(issueDetails);
  return [
    `Issue summary: ${issueTitle}`,
    '',
    'Location:',
    'When did you first notice it?',
    'What is happening?',
    'Any damage, safety risk, or urgent impact?',
  ].join('\n');
};
